var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('industry',{attrs:{"name":_vm.title,"solutions":_vm.solutions,"img":_vm.cover}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }